// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2-u9K","container":"styles_container__3Z32v","title":"styles_title__3rs6y","wrapper":"styles_wrapper__3c85o","answer":"styles_answer__2Ppkn"};